import { FlowModel } from './flow.model';
import { StageConfigurationObject } from './stage-configuration.model';
import { InvoiceRuleEvaluationModel } from '../../invoice-rule/models/invoice-rule-evaluation.model';
import { InvoiceRuleApplicationModel } from './invoice-rule-application.model';
import { InvoicingBusinessLogic } from '../../business-logic/models/invoicing-business-logic.model';

export class InvoiceFlowStageModel {
  id: number;
  name: string;
  stageType: InvoiceFlowStageTypes;
  invoiceFlowId: FlowModel['id'];
  invoiceType: InvoiceType;
  manualApproval: boolean;
  previousStageId?: number;
  allPreviousMustSucceed: boolean;
  businessLogic: InvoicingBusinessLogic;
  invoiceRuleEvaluation?: InvoiceRuleEvaluationModel[];
  invoiceRuleApplication?: InvoiceRuleApplicationModel;
  stageConfiguration?: StageConfigurationObject;

  constructor() {
    this.id = null;
    this.name = null;
    this.stageType = null;
    this.invoiceFlowId = null;
    this.invoiceType = null;
    this.manualApproval = false;
    this.previousStageId = null;
    this.allPreviousMustSucceed = false;
    this.businessLogic = new InvoicingBusinessLogic();
  }
}

export enum InvoiceFlowStageTypes {
  CalculateTariffs = 0,
  FinalizeInvoice = 3,
  Distribution = 4,
  CreditInvoice = 5,
  VerifyInvoice = 6,
  FollowUpInvoice = 7,
  ExtractExecutionData = 8,
  EnrichSourceData = 9,
  GenerateContent = 10,
  InvoiceLayout = 11,
  AdditionDataProcessing = 12,
}

export enum InvoiceType {
  Proforma = 1,
  Regular = 2,
  Credit = 3,
}

export interface StageTreeItem extends InvoiceFlowStageModel {
  children?: StageTreeItem[];
  indentLevel?: number;
}
